var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"at-empty-conversation"},[(_vm.svgIcon)?_c('guppy-svg-icons',{attrs:{"isEmptyView":true,"ImageColor":_vm.listIcon}}):_c('i',{class:_vm.listIcon}),(_vm.isSidebarProps)?_c('span',[_vm._v(_vm._s(_vm.TRANS.no_results))]):_c('span',[_vm._v(_vm._s(_vm.TRANS.start_conversation))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }